import Entity from './Entity'
export default class Venue extends Entity {
  name
  timeZone
}
